import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Usuario } from "@/shared/types/usuario";

export async function getUsuario(id: string): Promise<Usuario> {
    await sleep(1000);
    const response = await api.get("usuarios/" + id);
    return response.data;
}

export function useGetUsuarioQuery(id: string, queryConfig: QueryConfig<Usuario> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getUsuario(id),
        queryKey: ["usuarios", id],
    })
}

export interface GetUsuarioQueryProps {
    id: string,
    queryConfig?: QueryConfig<Usuario>,
    children?: (queryResult: QueryResult<Usuario>) => ReactNode
}

export function GetUsuarioQuery({
    id,
    children,
    queryConfig
}: GetUsuarioQueryProps) {
    const queryResult = useGetUsuarioQuery(id, queryConfig);
    return children && children(queryResult);
}